'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var plural = _interopDefault(require('plurals-cldr'));

var at = require('lodash/at');
var isEmpty = require('lodash/isEmpty');
var I18n = /** @class */ (function () {
    function I18n() {
        this.translations = {};
    }
    I18n.prototype.setTranslations = function (translations) {
        this.translations = translations;
    };
    I18n.prototype.setLocale = function (locale) {
        this.locale = locale;
    };
    I18n.prototype.setLocaleFallback = function (locale) {
        this.localeFallback = locale;
    };
    /**
     * Leverages Intl.NumberFormat for currency formatting
     */
    I18n.prototype.formatNumber = function (num, style, currency) {
        return new Intl.NumberFormat(this.locale, { style: style, currency: currency }).format(num);
    };
    /**
     * Retrieves a key from the translations object.
     */
    I18n.prototype.getKey = function (path) {
        if (isEmpty(this.translations)) {
            throw new Error('Translations have not been loaded');
        }
        var result = at(this.translations[this.locale], path)[0] || at(this.translations[this.localeFallback], path)[0];
        return result;
    };
    /**
     * Translate a key
     * Interpolate values with %{name}
     *
     * Examples:
     *
     * t('foo.bar') => 'Bar'
     * t('zemba.fleiba', {num: 3 }) => 'Zemba 3 Fleiba!'
     */
    I18n.prototype.t = function (path, opts) {
        var value = this.getKey(path);
        if (typeof value !== 'string') {
            throw new Error("Key \"" + path + "\" is not a leaf");
        }
        var MATCH = /%\{([^}]+)\}/g;
        return value.replace(MATCH, function (match, subst) {
            if (!opts)
                return '';
            return String(opts[subst]);
        });
    };
    /**
     * Translate singular o plural copies
     * Options must contain `count`
     *
     * Examples:
     *
     * tp('beer', { count: 3 }) => '3 beers'
     */
    I18n.prototype.tp = function (path, opts) {
        var num = opts.count;
        if (typeof num !== 'number') {
            throw new Error('You must have a `count` property and it must be a non-null number');
        }
        var form = plural(this.locale, num);
        var pluralPath = path + "." + form;
        try {
            return this.t(pluralPath, opts);
        }
        catch (e) {
            form = plural(this.localeFallback, num);
            pluralPath = path + "." + form;
            return this.t(pluralPath, opts);
        }
    };
    /**
     * Conditional copies, made easy.
     * Provide a path and then options, like classNames
     *
     * Example:
     *
     *   tx('fleiba.zemba', user.get('role'))
     */
    I18n.prototype.tx = function (path, variable, opts) {
        var newPath = path + "." + variable;
        return this.t(newPath, opts);
    };
    return I18n;
}());

module.exports = I18n;
